/**
 * Meta tags and site-search entry for `/register` (`pages/register/index.tsx`). The `fr` and `es`
 * entries repeat the English. The later registration steps have no meta content of their own.
 */
import { MetaContent } from "@components/Shared/model/MetaHead";
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { LanguageContent } from "@ryerson/frontend.common";

/** Title, description and canonical path for `/register`, read by `MetaHead`. */
export const RegisterMetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Register for an Online Account - Ryerson",
		description: `Create an online account to track your order, faster checkout and access an industry leading experience`,
		url: `/register`,
		company: true,
	},
	fr: {
		title: "Register for an Online Account - Ryerson",
		description: `Create an online account to track your order, faster checkout and access an industry leading experience`,
		url: `/register`,
		company: true,
	},
	es: {
		title: "Register for an Online Account - Ryerson",
		description: `Create an online account to track your order, faster checkout and access an industry leading experience`,
		url: `/register`,
		company: true,
	},
};

/**
 * The `/register` entry in `public/search-site.json`: listed in `scripts/staticSearch.ts`, which
 * serialises it. Meta only, with no body content.
 */
export const RegisterPageContent: StaticPageContent = {
	meta: RegisterMetaObject,
	content: [],
};
